<template>
  <button class="wizard-back-button" type="button" @click="goBack">
    <font-awesome-icon icon="arrow-left" /> Назад к исполнителю
  </button>
</template>

<script>
import { useRouter } from 'vue-router'

export default {
  name: 'ExecutorWizardBackButton',
  setup() {
    const router = useRouter()

    const goBack = () => router.push({ name: 'ExecutorWizardHub' })

    return { goBack }
  },
}
</script>

<style scoped>
.wizard-back-button {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
  border: 1px solid #d7dce2;
  border-radius: 8px;
  background-color: #fff;
  color: #333;
  cursor: pointer;
}

.wizard-back-button:hover {
  background-color: #f5f5f5;
}
</style>
